/*
 * Define the expected configuration variables
 */
export type Config = {
  REACT_APP_ENV: string;

  PEACHJAR_DOMAIN: string;
  // API Urls
  REACT_APP_ACCOUNTS_BFF_URI: string;
  // Parent app BFF
  REACT_APP_PARENT_APP_BFF: string;

  // GTM Tag ID
  REACT_APP_GTM_TAG: string;

  REACT_APP_ACCOUNTS_URL: string;

  REACT_APP_BASE_URL: string;

  REACT_APP_ACCOUNTS_BFF_BASE_URL: string;

  REACT_APP_INTERNAL_BFF_BASE_URL: string;

  REACT_APP_FEATURE_FLAG_NAME: string;

  REACT_APP_DISABLE_FEATURE_FLAG_VERIFICATION: boolean;

  V1_API_HOST_NAME: string;

  V2_API_HOST_NAME: string;

  REACT_APP_SHARE_HOST: string;
};

/**
 * Load a configuration based on the domain (which is how we dynamically determine the environment)
 *
 * @param {string} domain
 */
function getConfig(domain: string): Config {
  switch (domain) {
    // For production, use the following configuration
    case 'my.peachjar.com':
      return {
        REACT_APP_ENV: 'production',
        PEACHJAR_DOMAIN: 'peachjar.com',
        REACT_APP_ACCOUNTS_BFF_URI: 'https://accounts-bff.peachjar.com/graphql',
        REACT_APP_PARENT_APP_BFF: 'https://parent-app-bff.peachjar.com/graphql',
        REACT_APP_GTM_TAG: 'GTM-WRWNQXN',
        REACT_APP_ACCOUNTS_URL: 'https://accounts.peachjar.com/',
        REACT_APP_BASE_URL: 'https://my.peachjar.com',
        REACT_APP_ACCOUNTS_BFF_BASE_URL: 'https://accounts-bff.peachjar.com',
        REACT_APP_INTERNAL_BFF_BASE_URL: 'https://internal-bff.peachjar.com',
        REACT_APP_FEATURE_FLAG_NAME: 'release_parent_experience',
        REACT_APP_DISABLE_FEATURE_FLAG_VERIFICATION: true,
        V1_API_HOST_NAME: 'https://flyers-bff.peachjar.com',
        V2_API_HOST_NAME: 'https://portal-bff.peachjar.com',
        REACT_APP_SHARE_HOST: 'https://share.peachjar.com',
      };

    // For Kauai or any other environment, use the following configuration
    case 'parent-app.peachjar-kauai.com':
      return {
        REACT_APP_ENV: 'development',
        PEACHJAR_DOMAIN: 'peachjar-kauai.com',
        REACT_APP_PARENT_APP_BFF: 'https://parent-app-bff.peachjar-kauai.com/graphql',
        REACT_APP_ACCOUNTS_BFF_URI: 'https://accounts-bff.peachjar-kauai.com/graphql',
        REACT_APP_GTM_TAG: 'GTM-KCX8GFH',
        REACT_APP_ACCOUNTS_URL: 'https://accounts.peachjar-kauai.com/',
        REACT_APP_BASE_URL: 'https://parent-app.peachjar-kauai.com',
        REACT_APP_ACCOUNTS_BFF_BASE_URL: 'https://accounts-bff.peachjar-kauai.com',
        REACT_APP_INTERNAL_BFF_BASE_URL: 'https://internal-bff.peachjar-kauai.com',
        REACT_APP_FEATURE_FLAG_NAME: 'release_parent_experience',
        REACT_APP_DISABLE_FEATURE_FLAG_VERIFICATION: true,
        V1_API_HOST_NAME: 'https://flyers-bff.peachjar-kauai.com',
        V2_API_HOST_NAME: 'https://portal-bff.peachjar-kauai.com',
        REACT_APP_SHARE_HOST: 'https://share.peachjar-kauai.com',
      };
    case 'parent-app-demo.peachjar-kauai.com':
      return {
        REACT_APP_ENV: 'development',
        PEACHJAR_DOMAIN: 'peachjar-kauai.com',
        REACT_APP_PARENT_APP_BFF: 'https://parent-app-bff.peachjar-kauai.com/graphql',
        REACT_APP_ACCOUNTS_BFF_URI: 'https://accounts-bff.peachjar-kauai.com/graphql',
        REACT_APP_GTM_TAG: 'GTM-KCX8GFH',
        REACT_APP_ACCOUNTS_URL: 'https://accounts.peachjar-kauai.com/',
        REACT_APP_BASE_URL: 'https://parent-app-demo.peachjar-kauai.com',
        REACT_APP_ACCOUNTS_BFF_BASE_URL: 'https://accounts-bff.peachjar-kauai.com',
        REACT_APP_INTERNAL_BFF_BASE_URL: 'https://internal-bff.peachjar-kauai.com',
        REACT_APP_FEATURE_FLAG_NAME: 'release_parent_experience',
        REACT_APP_DISABLE_FEATURE_FLAG_VERIFICATION: true,
        V1_API_HOST_NAME: 'https://flyers-bff.peachjar-kauai.com',
        V2_API_HOST_NAME: 'https://portal-bff.peachjar-kauai.com',
        REACT_APP_SHARE_HOST: 'https://share.peachjar-kauai.com',
      };

    case 'localhost':
    case 'peachjar.net':
    default:
      return {
        REACT_APP_ENV: 'development',
        PEACHJAR_DOMAIN: 'peachjar.net:10443',
        REACT_APP_ACCOUNTS_BFF_URI: 'https://accounts-bff.peachjar.net:10443/graphql',
        REACT_APP_PARENT_APP_BFF: 'https://parent-app-bff.peachjar.net:10443/graphql',
        REACT_APP_GTM_TAG: 'GTM-KCX8GFH',
        REACT_APP_ACCOUNTS_URL: 'https://accounts.peachjar.net:10443',
        REACT_APP_BASE_URL: 'https://parent-app.peachjar.net:10443',
        REACT_APP_ACCOUNTS_BFF_BASE_URL: 'https://accounts-bff.peachjar.net:10443',
        REACT_APP_INTERNAL_BFF_BASE_URL: 'https://internal-bff.peachjar.net:10443',
        REACT_APP_FEATURE_FLAG_NAME: 'release_DEV_2312_foobar',
        REACT_APP_DISABLE_FEATURE_FLAG_VERIFICATION: true,
        V1_API_HOST_NAME: 'https://flyers-bff.peachjar.net:10443',
        V2_API_HOST_NAME: 'https://portal-bff.peachjar.net:10443',
        REACT_APP_SHARE_HOST: 'https://share.peachjar-kauai.com',
      };
  }
}

export default getConfig(window.location.hostname);
